import { Columns2, Plus, Tags } from "lucide-react"

import { ExportAll } from "@/components/rules/export-all"
import { RulesView } from "@/components/rules/rules-view"
import { Inactive } from "@/components/ui/inactive"

/**
 * Вкладка Custom rules — 458 правил из выгрузки SEON.
 *
 * Сортировка по умолчанию — `Created` по убыванию, как в образце: самое свежее
 * правило первым.
 *
 * `New rule`, `Manage categories` и `View settings` нарисованы, но не работают:
 * редактирование правил в этой консоли не делается вовсе — скоринг живёт в
 * SEON, а здесь только чтение каталога и включение/выключение. Кнопки
 * оставлены, чтобы совпадал состав панели, и каждая объясняет подсказкой,
 * почему неактивна.
 */
export function CustomRulesTab() {
  return (
    <RulesView
      type="custom"
      title="Custom rules"
      extended
      defaultSort={{ sort: "created", order: "desc" }}
      actions={
        <>
          <Inactive
            variant="primary"
            reason="Rules are authored in SEON. This console does not create or edit them."
          >
            <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
            New rule
          </Inactive>
          <Inactive reason="Categories come from the SEON export and are not editable here.">
            <Tags className="h-3.5 w-3.5" strokeWidth={2} />
            Manage categories
          </Inactive>
          <Inactive reason="Column layout is fixed in this build.">
            <Columns2 className="h-3.5 w-3.5" strokeWidth={2} />
            View settings
          </Inactive>
          <ExportAll type="custom" />
        </>
      }
    />
  )
}
